import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AppList } from 'components/AppList';

export default class InstalledApps extends Component {
  static propTypes = {
    apps: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    appDigestProps: PropTypes.shape().isRequired
  };

  render() {
    const { apps, appDigestProps } = this.props;
    return (
      <div>
        {apps && apps.length ? (
          <AppList apps={apps} appDigestProps={appDigestProps} />
        ) : (
          <span />
        )}
      </div>
    );
  }
}
